/**
 * API Configuration
 * Centralized configuration for API endpoints and application URLs
 * Uses environment variables from .env files
 */

// API Base URL - backend endpoint
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/Hashtag/backend/api';

// Application URL - frontend URL for meta tags and SEO
export const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:5173';

// Helper function to build API endpoint URL
export const getApiEndpoint = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${API_URL}/${cleanPath}`;
};

// Helper function to build application URL
export const getAppUrl = (path = '') => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return cleanPath ? `${APP_URL}/${cleanPath}` : APP_URL;
};

export default {
    API_URL,
    APP_URL,
    getApiEndpoint,
    getAppUrl
};
